import { memo, useState } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import { AttachArticles } from "@coworker/apprestructured/src/task-management/components/AttachArticles/AttachArticles";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { useItemsInfoQueries } from "@coworker/apprestructured/src/shared/hooks/item/useItemsInfo";
import { Item } from "@coworker/apprestructured/src/shared/types/item";

function AttachArticlesDemo() {
  const [itemNos, setItemNos] = useState<string[]>([]);
  const [disabled, setDisabled] = useState(false);
  const items = useItemsInfoQueries(itemNos)
    .map(({ data }) => data)
    .filter(Boolean) as Item[];

  return (
    <Demo>
      <Name>AttachArticles</Name>
      <Highlight>
        <FixaListView id="attacharticlesdemo" size="small">
          <AttachArticles
            items={items}
            setItemNos={setItemNos}
            disabled={disabled}
          />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaCheckbox
          label="disabled"
          value="attacharticlesdemo-disabled"
          id="attacharticlesdemo-disabled"
          checked={disabled}
          onChange={() => setDisabled((prev) => !prev)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(AttachArticlesDemo);
